import { AutoComplete, Button, Card, Col, Descriptions, Divider, Flex, Form, Grid, Input, InputNumber, message, Modal, Progress, Radio, Row, Select, Space, Steps, Typography, Upload } from "antd";
import { useEffect, useRef, useState } from "react";
import RenderIf from "../../components/RenderIf";
import { Icon } from "@iconify/react/dist/iconify.js";
import pallete from "../../utils/pallete";
import ReactSignatureCanvas from "react-signature-canvas";
import { Link, useNavigate, useParams } from "react-router";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { surveyService } from "../../services/survey.service";
import UploadFileRenderer from "../../components/FileUploadRenderer";
import { skemaPembayaran, sumberAir } from "../../utils/options.data";
import { MAX_FILE_SIZE } from "../../utils/const";
import { indonesiaRegionService } from "../../services/indonesia-region.service";
import { API_BASE_URL } from "../../config/api.config";
import TnC from "../../components/TnC";
import { canUploadImage } from "../../utils/imageValidator";
import { masterDataTypeService } from "../../services/master-data-type.service";
import MapComponent from "../../components/Maps";
import useDebounce from "../../hooks/useDebounce";
import { mapsService } from "../../services/maps.service";


const validateForm = [
  ['nama', 'nama_penanggung_jawab', 'telepon', 'no_hp', 'no_nik', 'no_kk', 'no_pbb', 'no_sertifikat', 'email', 'kota', 'kecamatan', 'kelurahan', 'jalan', 'no_rumah', 'kode_pos', 'rt', 'rw', 'status_penghuni', 'jumlah_penghuni', 'lingkungan_tertata', 'jenis_pemukiman_id', 'luas_bangunan', 'kode_tarif_id'],
  ['lokasi_bangunan', 'latitude', 'longitude'],
  ['novak_blok', 'nomen_terdekat', 'sumber_lain', 'jaringan_pipa', 'jarak_bangunan_dengan_pipa', 'ukuran_pipa_id', 'diameter_pipa_id', 'jenis_jalan_id', 'perlu_crossing_jalan', 'lebar_jalan', 'perlu_crossing_air', 'panjang_casing_pipa', 'perlu_crossing_air', 'sanitasi', 'saluran_pembuangan', 'halaman', 'golongan_konsumen_id', 'nomen_lama', 'tekanan_air', 'peruntukan_bangunan', 'perlu_bor_tembok', 'lebar_jalan', 'cc', 'pa_pc', 'blok_ez'],
  ['kamar_tidur', 'kamar_mandi', 'ruang_tamu', 'ruang_makan', 'ruang_keluarga', 'dapur', 'teras', 'garasi', 'gudang', 'jumlah_lantai'],
  ['skema_pembayaran', 'keterangan_lain', 'program_sambungan_baru_id', 'program_kategori', 'nama_program_kategori', 'object_id_bnba', 'field_survey_id_maps_bnba']
]

const steps = ['Pelanggan', 'Titik Koordinat', 'Lokasi', 'Bangunan', 'Dokumen & Informasi Tambahan', 'Persetujuan', 'Selesaikan Survey', 'Foto Pelanggan']


const addressNumberFormatter = {
  formatter: (value) => {
    const numericValue = value.replace(/\D/g, '');

    if (numericValue) {
      return numericValue.padStart(3, '0');
    }
    return '';
  },
  parser: (value) => {
    return value.replace(/\D/g, '');
  }
}

// eslint-disable-next-line react/prop-types
const FormField = ({ label, name, rules, type = "text", children }) => (
  <Form.Item label={label} name={name} rules={rules}>
    {children || <Input type={type} />}
  </Form.Item>
);

const getFileExtension = (filename) => {
  return filename.split('.').pop().toLowerCase();
};

export default function SurveyDetail() {

  const queryClient = useQueryClient();

  const navigate = useNavigate()

  const { id } = useParams()
  const [form] = Form.useForm()

  const breakpoint = Grid.useBreakpoint()

  const [stepPosition, setStepPosition] = useState(0);
  const [customerSignature, setCustomerSignature] = useState('')
  const [surveyorSignature, setSurveyorSignature] = useState('')
  const [previewImage, setPrevieImage] = useState('')


  const [selectedAddress, setSelectedAddress] = useState('')
  const [searchAddress, setSearchAddress] = useState('')
  const [position, setPosition] = useState([-6.1995, 106.8118])

  const addressDebounce = useDebounce(searchAddress, 300)

  const [selectedCity, setSelectedCity] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')

  const [customerImage, setCustomerImage] = useState([])
  const [serviceLetter, setServiceLetter] = useState([])
  const [additionalLetter, setAdditionalLetter] = useState([])
  const [changedDocument, setChangedDocument] = useState([])
  const [changedDocumentType, setChangedDocumentType] = useState('')

  const signatureRef = useRef()
  const [signatureConf, setSignatureConf] = useState({
    modal: false,
    target: '',
    signatureUrl: ''
  })

  const [tncAgree, setTnCAgree] = useState(false);
  const [openChangeModal, setOpenChangedDocument] = useState(false)

  const city = Form.useWatch('kota', form)
  const district = Form.useWatch('kecamatan', form)

  const { data } = useQuery({
    queryKey: ['detailSurvey', id],
    queryFn: () => surveyService.getById(id),
    enabled: !!id
  })

  const { data: jenisPemukimanMaster } = useQuery({
    queryKey: ['jenisPemukiman'],
    queryFn: () => masterDataTypeService.getByName('Jenis Pemukiman'),
  })

  const { data: kodeTarifMaster } = useQuery({
    queryKey: ['kodeTarif'],
    queryFn: () => masterDataTypeService.getByName('Kode Tarif'),
  })

  const { data: ukuranPipaMaster } = useQuery({
    queryKey: ['ukuranPipa'],
    queryFn: () => masterDataTypeService.getByName('Ukuran Pipa'),
  })

  const { data: jenisJalanMaster } = useQuery({
    queryKey: ['jenisJalan'],
    queryFn: () => masterDataTypeService.getByName('Jenis Jalan'),
  })

  const { data: golonganKonsumenMaster } = useQuery({
    queryKey: ['golonganKonsumen'],
    queryFn: () => masterDataTypeService.getByName('Golongan Konsumen'),
  })

  const { data: diameterPipaMaster } = useQuery({
    queryKey: ['diameterPipa'],
    queryFn: () => masterDataTypeService.getByName('Diameter Pipa Dinas'),
  })

  const { data: programSambunganBaru } = useQuery({
    queryKey: ['programSambunganBaru'],
    queryFn: () => masterDataTypeService.getByName('Program Sambungan Baru'),
  })

  const { data: cities } = useQuery({
    queryKey: ['cities'],
    queryFn: () => indonesiaRegionService.getCities()
  })

  const { data: districts } = useQuery({
    queryKey: ['districts', selectedCity],
    queryFn: () => indonesiaRegionService.getDistricts(selectedCity),
    enabled: !!city
  })

  useEffect(() => {
    form.resetFields(['kecamatan', 'kelurahan'])

    if (city) {
      const selected = cities.find(e => e.name == city)
      setSelectedCity(selected?.id)
    }
  }, [city])

  const { data: villages } = useQuery({
    queryKey: ['villages', selectedDistrict],
    queryFn: () => indonesiaRegionService.getSubdistricts(selectedDistrict),
    enabled: !!district
  })

  const { data: addressResponse } = useQuery({
    queryKey: ['searchAddress', addressDebounce],
    queryFn: () => mapsService.searchAddress(addressDebounce),
    enabled: !!addressDebounce
  })

  const reverseGeocodeMutation = useMutation({
    mutationFn: (coords) => {
      const lat = coords?.lat ?? position[0];
      const lng = coords?.lng ?? coords?.lon ?? position[1];
      return mapsService.reverseGeocode(lat, lng);
    },
    onSuccess: (data) => {
      setSelectedAddress(data.display_name)
      form.setFieldsValue({ lokasi_bangunan: data.display_name, latitude: Number(data.lat), longitude: Number(data.lon) });
    }
  })

  const storeMutation = useMutation({
    mutationKey: ['storeMutation'],
    mutationFn: val => surveyService.create(val),
    onSuccess: (res) => {
      message.success("Data berhasil disimpan")
      return navigate("/survey/detail/" + res.data.id)
    },
    onError: (res) => {
      console.log(res)
      message.error("Terjadi kesalahan")
    }
  })

  const updateMutation = useMutation({
    mutationKey: ['updateSurvey'],
    mutationFn: val => surveyService.update(val),
    onSuccess: () => {
      message.success("Data berhasil disimpan")
      queryClient.invalidateQueries('detailSurvey')
    },
    onError: (res) => {
      console.log(res)
      message.error("Terjadi kesalahan")
    }
  })

  const finishSurveyMutation = useMutation({
    mutationKey: ['finishSurvey'],
    mutationFn: () => surveyService.finishSurvey(id),
    onSuccess: () => {
      message.success("Data berhasil dikirim")
      return navigate("/survey")
    },
    onError: (res) => {
      console.log(res)
      message.error("Terjadi kesalahan")
    },
  })

  const uploadFileMutation = useMutation({
    mutationKey: ['uploadAdditional'],
    mutationFn: val => surveyService.uploadAdditionalLetter(id, val),
  })

  const uploadServiceLetterMutation = useMutation({
    mutationKey: ['uploadService'],
    mutationFn: val => surveyService.uploadServiceLetter(id, val),
  })

  const uploadCustomerImageMutation = useMutation({
    mutationFn: val => surveyService.uploadCustomerImage(id, val),
  })

  const changedDocumentMutation = useMutation({
    mutationFn: val => surveyService.changeDocument(id, val),
    onSuccess: () => {
      setOpenChangedDocument(false)
      message.success("Document Berhasil diubah")
      queryClient.invalidateQueries('detailSurvey')
    },
    onError: (err) => {
      console.log(err)
    }
  })

  const deleteFileMutation = useMutation({
    mutationKey: ['deleteFile'],
    mutationFn: val => surveyService.deleteFile(id, val),
    onSuccess: () => {
      message.success("Data berhasil dihapus")
    },
    onError: (res) => {
      console.log(res)
      message.error("Terjadi kesalahan")
    }
  })

  useEffect(() => {
    if (id) {
      form.setFieldsValue(data?.data)
      setSelectedAddress(data?.data.lokasi_bangunan)
      form.setFieldValue('latitude', Number(data?.data.koordinat.latitude))
      form.setFieldValue('longitude', Number(data?.data.koordinat.longitude))
      setPosition([Number(data?.data.koordinat.latitude), Number(data?.data.koordinat.longitude)])

      if (data?.data.kota) {
        const selectedCity = cities?.find(e => e.name == data?.data.kota)
        setSelectedCity(selectedCity?.id)
      }

      if (data?.data.kecamatan && districts) {
        const selectedDistrict = districts.find(e => e.name == data?.data.kecamatan)
        setSelectedDistrict(selectedDistrict.id)
      }

      if (data?.data?.serviceLetter) {
        setServiceLetter([
          {
            ...data?.data?.serviceLetter,
            name: data?.data?.serviceLetter.fileName,
            size: data?.data?.serviceLetter.fileSize,
            preview: `${API_BASE_URL}/files/${data?.data?.serviceLetter.filePath}`
          }
        ])
      }

      if (data?.data?.additionalLetter) {
        setAdditionalLetter(
          data?.data?.additionalLetter.map(e => ({
            ...e,
            name: e.fileName,
            size: e.fileSize,
            preview: `${API_BASE_URL}/files/${e.filePath}`
          }))
        )
      }

      if (data?.data?.customerImage) {
        setCustomerImage(
          data?.data?.customerImage.map(e => ({
            ...e,
            name: e.fileName,
            size: e.fileSize,
            preview: `${API_BASE_URL}/files/${e.filePath}`
          }))
        )
      }

      if (data?.data?.tanda_tangan_pelanggan) {
        setTnCAgree(true)
        setCustomerSignature(data?.data?.tanda_tangan_pelanggan)
      }

      if (data?.data?.tanda_tangan_surveyor) {
        setSurveyorSignature(data?.data?.tanda_tangan_surveyor)
      }

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, id, stepPosition])

  useEffect(() => {
    if (districts) {
      const selectedDistrict = districts.find(e => e.name == data?.data?.kecamatan)
      if (selectedDistrict) {
        setSelectedDistrict(selectedDistrict.id)
        form.setFieldValue('kecamatan', data?.data.kecamatan)
      }
    }
  }, [districts])

  useEffect(() => {
    if (villages) {
      const isVillagesInList = villages.find(e => e.name == data?.data.kelurahan)
      if (isVillagesInList)
        form.setFieldValue('kelurahan', data?.data.kelurahan)
    }
  }, [villages])

  const handleFinishSignature = () => {
    if (signatureConf.target == 'customer') {
      const sigUrl = signatureRef.current.toDataURL()
      updateMutation.mutateAsync({ tanda_tangan_pelanggan: sigUrl, id })
        .then(() => {
          setCustomerSignature(sigUrl)
          signatureRef.current.clear()
          handleCloseModal()
        })
        .catch(err => console.log(err))
    }

    if (signatureConf.target == 'surveyor') {
      const sigUrl = signatureRef.current.toDataURL()
      updateMutation.mutateAsync({ tanda_tangan_surveyor: sigUrl, id })
        .then(() => {
          setSurveyorSignature(sigUrl)
          signatureRef.current.clear()
          handleCloseModal()
        })
        .catch(err => console.log(err))
    }


  }

  const handleSignature = target => {
    setSignatureConf(() => ({
      signatureUrl: '',
      target,
      modal: true,
    }))
  }

  const handleCloseModal = () => {
    setSignatureConf(() => ({
      signatureUrl: '',
      target: '',
      modal: false,
    }))
  }

  const handleSelectAddress = (val) => {
    const selected = addressResponse?.find(e => e.display_name == val)
    setSelectedAddress(selected.display_name)
    setPosition([Number(selected.lat), Number(selected.lon)])
    form.setFieldValue('lokasi_bangunan', selected.display_name)
    form.setFieldValue('latitude', Number(selected.lat))
    form.setFieldValue('longitude', Number(selected.lon))
  }

  const handleClearSignature = () => signatureRef.current.clear()

  const handleNext = () => {

    form.validateFields(validateForm[stepPosition]).then(() => {

      const data = form.getFieldsValue(validateForm[stepPosition])

      if (!id) {
        storeMutation.mutate(data)
        return
      }

      updateMutation.mutate({ ...data, id })
      setStepPosition(stepPosition + 1)
    })

  }

  const handleDeleteSignature = target => {
    if (target == 'customer') {
      updateMutation.mutateAsync({ tanda_tangan_pelanggan: null, id })
        .then(() => setCustomerSignature(''))
        .catch(err => console.log(err))
    }

    if (target == 'surveyor') {
      updateMutation.mutateAsync({ tanda_tangan_surveyor: null, id })
        .then(() => setSurveyorSignature(''))
        .catch(err => console.log(err))
    }

  }

  const handleFinishSurvey = () => {

    Modal.confirm({
      centered: true,
      title: "Pemberitahuan",
      content: "Yakin ingin selesaikan survey ?",
      okText: 'Ya',
      cancelText: 'Batal',
      onOk: () => finishSurveyMutation.mutate(),
      okButtonProps: { loading: finishSurveyMutation.isPending, disabled: finishSurveyMutation.isPending },
      cancelButtonProps: { loading: finishSurveyMutation.isPending, disabled: finishSurveyMutation.isPending }
    })

  }

  const getBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  const preprocessUpload = async (file) => {
    file.preview = await getBase64(file)
    if (!canUploadImage(file.name)) {
      message.error(`Format file tidak benar`);
      return Upload.LIST_IGNORE; // 
    }
    if (file.size > MAX_FILE_SIZE) {
      message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
      return Upload.LIST_IGNORE; // Mencegah upload
    }
  }

  const handleCloseChangedDocumentModal = () => {
    setChangedDocument([])
    setOpenChangedDocument(false)
  }

  const onChangeDocument = (type) => {
    setChangedDocumentType(type)
    setOpenChangedDocument(true)
  }

  const handleChangeDocument = () => changedDocumentMutation.mutate({ file: changedDocument[0], type: changedDocumentType })

  const handleChangePlace = (place, value) => {

    if (place == 'city') {
      const c = cities.find(e => e.name == value)
      setSelectedCity(c.id)
    }

    if (place == 'district') {
      form.resetFields(['kelurahan'])
      const d = districts.find(e => e.name == value)
      setSelectedDistrict(d.id)
    }

  }

  const handleUseCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setPosition([pos.coords.latitude, pos.coords.longitude])
        form.setFieldValue('latitude', pos.coords.latitude)
        form.setFieldValue('longitude', pos.coords.longitude)
        reverseGeocodeMutation.mutate({ lat: pos.coords.latitude, lon: pos.coords.longitude })
      },
      (error) => {
        message.error("Gagal mendapatkan lokasi saat ini")
        console.log(error)
      }
    )
  }

  return (
    <>
      <Modal
        title={`Tanda Tangan ${signatureConf.target?.replace(/\b\w/g, char => char.toUpperCase())}`}
        open={signatureConf.modal}
        centered
        width={'fit-content'}
        okText="Simpan"
        onOk={handleFinishSignature}
        onCancel={handleCloseModal}
        cancelButtonProps={{ variant: 'outlined', color: 'primary' }}
        footer={(origin, { CancelBtn, OkBtn }) => {
          return (
            <Flex gap={18} >
              <Button onClick={handleClearSignature} variant="outlined" color="danger" style={{ marginRight: 'auto' }} >
                Hapus
              </Button>
              <CancelBtn />
              <OkBtn />
            </Flex>
          )
        }}
      >
        <ReactSignatureCanvas
          ref={ref => signatureRef.current = ref}
          penColor='black'
          canvasProps={{
            width: breakpoint.xs ? 350 : 500,
            height: 200,
            style: {
              border: `1px solid ${pallete.grey[300]}`,
              borderRadius: 6
            }
          }}
        />
      </Modal>
      <Card
        title="Detail Survey Pelanggan"
        actions={[
          <Flex key={'1'} justify="end" gap={16} style={{ paddingRight: 24, paddingLeft: 24 }} >
            <Button
              block={breakpoint.xs}
              onClick={() => stepPosition == 0 ? navigate('/survey') : setStepPosition(stepPosition - 1)}
              variant="outlined"
              color="primary"
            >
              Kembali
            </Button>
            <Button
              onClick={stepPosition != 6 ? handleNext : handleFinishSurvey}
              variant="solid"
              disabled={stepPosition == 6 && ((customerSignature.length == 0) || (surveyorSignature.length == 0))}
              color="primary"
              block={breakpoint.xs}
            >
              {stepPosition != 6 ? 'Selanjutnya' : 'Submit'}
            </Button>
          </Flex>
        ]}
      >
        <RenderIf when={breakpoint.xs} >
          <Space style={{ marginBottom: 20 }} >
            <Progress
              percent={((stepPosition + 1) / 6) * 100}
              type="circle"
              size={80}
              format={() => (
                <Typography.Text>
                  {`${stepPosition + 1} dari 6`}
                </Typography.Text>
              )}
            />
            <Space direction="vertical" >
              <Typography.Title level={4} style={{ margin: 0 }} >
                {steps[stepPosition]}
              </Typography.Title>
              <Typography.Text type="secondary" >
                Selanjutnya : {steps[stepPosition + 1]}
              </Typography.Text>
            </Space>
          </Space>
        </RenderIf>
        <Flex gap={40} >
          <Form
            layout="vertical"
            style={{ flex: 1 }}
            form={form}
          >
            <Form.Item name={'id'} hidden >
              <Input />
            </Form.Item>
            <RenderIf when={stepPosition === 0} >
              <Row gutter={[20]} >
                <Col span={12} >
                  <FormField name={'nama'} label={'Nama'} rules={[{ required: true }]} />
                </Col>
                <Col span={12} >
                  <FormField name={'nama_penanggung_jawab'} label={'Nama Penanggung Jawab'} rules={[{ required: true }]} />
                </Col>
                <Col sm={12} xs={24} >
                  <FormField
                    name={'no_nik'}
                    label={'No KTP'}
                    rules={[{ required: true }]}
                  >
                    <Input style={{ width: '100%' }} />
                  </FormField>
                </Col>
                <Col sm={12} xs={24} >
                  <FormField
                    name={'no_kk'}
                    label={'No KK'}
                    rules={[{ required: true }]}
                  >
                    <Input style={{ width: '100%' }} />
                  </FormField>
                </Col>
                <Col sm={12} xs={24} >
                  <FormField
                    name={'no_pbb'}
                    label={'No PBB'}
                    rules={[{ required: true }]}
                  >
                    <Input style={{ width: '100%' }} />
                  </FormField>
                </Col>
                <Col sm={12} xs={24} >
                  <FormField
                    name={'no_sertifikat'}
                    label={'No Sertifikat'}
                    rules={[{ required: true }]}
                  >
                    <Input style={{ width: '100%' }} />
                  </FormField>
                </Col>
                <Col sm={6} xs={24} >
                  <FormField
                    name={'telepon'}
                    label={'No Telepon'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </FormField>
                </Col>
                <Col sm={6} xs={24} >
                  <FormField
                    name={'no_hp'}
                    label={'No HP'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </FormField>
                </Col>
                <Col sm={12} xs={24} >
                  <FormField name={'email'} label={'Email'} type="email" rules={[{ required: true, type: 'email' }]} />
                </Col>
              </Row>
              <Row gutter={[20]} >
                <Col xs={24} md={12} >
                  <FormField name={'kota'} label={'Kota'} rules={[{ required: true }]}>
                    <Select
                      options={cities?.map(e => ({ label: e.name, value: e.name }))}
                      onChange={(val) => handleChangePlace('city', val)}
                    />
                  </FormField>
                </Col>
                <Col xs={24} md={12} >
                  <FormField name={'kecamatan'} label={'Kecamatan'} rules={[{ required: true }]}>
                    <Select
                      options={districts?.map(e => ({ label: e.name, value: e.name }))}
                      onChange={(val) => handleChangePlace('district', val)}
                    />
                  </FormField>
                </Col>
              </Row>
              <Row gutter={[20]} >
                <Col xs={24} md={12} >
                  <FormField name={'kelurahan'} label={'Kelurahan'} rules={[{ required: true }]}>
                    <Select
                      options={villages?.map(e => ({ label: e.name, value: e.name }))}
                    />
                  </FormField>
                </Col>
                <Col xs={24} md={12} >
                  <FormField name={'jalan'} label={'Jalan'} rules={[{ required: true }]} />
                </Col>
              </Row>
              <Row gutter={[20]} >
                <Col xs={12} md={6} >
                  <FormField name={'no_rumah'} label={'No Rumah'} rules={[{ required: true }]} />
                </Col>
                <Col xs={12} md={6} >
                  <FormField name={'kode_pos'} label={'Kode Pos'} rules={[{ required: true }]}>
                    <InputNumber
                      style={{ width: '100%' }}
                    />
                  </FormField>
                </Col>
                <Col xs={12} md={6} >
                  <FormField name={'rt'} label={'RT'} rules={[{ required: true }]}>
                    <InputNumber
                      style={{ width: '100%' }}
                      {...addressNumberFormatter}
                    />
                  </FormField>
                </Col>
                <Col xs={12} md={6} >
                  <FormField name={'rw'} label={'RW'} rules={[{ required: true }]}>
                    <InputNumber
                      style={{ width: '100%' }}
                      {...addressNumberFormatter}
                    />
                  </FormField>
                </Col>
              </Row>
              <Row gutter={[20]} >
                <Col span={12} >
                  <Form.Item
                    label="Status Penghuni"
                    name={'status_penghuni'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={['Pemilik', 'Saudara/Kerabat', 'Penyewa'].map(e => ({ label: e, value: e }))}
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Jumlah Penghuni"
                    name={'jumlah_penghuni'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Lingkungan Tertata"
                    name={'lingkungan_tertata'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Ya'} >Ya</Radio>
                      <Radio value={'Tidak'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Jenis Pemukiman"
                    name={'jenis_pemukiman_id'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={jenisPemukimanMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                      showSearch
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                label="Kode Tarif"
                name={'kode_tarif_id'}
                rules={[{ required: true }]}
              >
                <Select
                  options={kodeTarifMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>
              <Form.Item
                label="Luas Bangunan"
                name={'luas_bangunan'}
                rules={[{ required: true }]}
              >
                <InputNumber style={{ width: '100%' }} suffix="m2" />
              </Form.Item>
            </RenderIf>
            <RenderIf when={stepPosition === 1} >
              <Form.Item
                name={'latitude'}
                hidden
              >
                <Input />
              </Form.Item>
              <Form.Item
                name={'longitude'}
                hidden
              >
                <Input />
              </Form.Item>
              <Row gutter={[20]} >
                <Col span={12} >
                  <Form.Item label="Latitude" >
                    <Input style={{ backgroundColor: pallete.grey[200] }} readOnly value={data?.data?.ab?.KOORDINAT.LATITUDE} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item label="Longitude" >
                    <Input style={{ backgroundColor: pallete.grey[200] }} readOnly value={data?.data?.ab?.KOORDINAT.LONGITUDE} />
                  </Form.Item>
                </Col>
              </Row>
              <Flex align="end" gap={10} style={{ marginBottom: 18 }} >
                <Form.Item
                  label="Titik Lokasi Bangunan"
                  name={'lokasi_bangunan'}
                  rules={[{ required: true }]}
                  style={{ flex: 1, marginBottom: 0 }}
                >
                  <AutoComplete
                    value={selectedAddress}
                    onSearch={setSearchAddress}
                    onSelect={handleSelectAddress}
                    options={addressResponse?.map(e => (
                      {
                        value: e.display_name,
                        label: (
                          <Space direction="vertical" size={3} >
                            <Typography.Text style={{ fontSize: 12, fontWeight: 600, margin: 0 }} >
                              {e.name}
                            </Typography.Text>
                            <Typography.Text style={{ fontSize: 12, color: pallete.grey[700], margin: 0 }} >
                              {e.display_name}
                            </Typography.Text>
                          </Space>
                        )
                      }
                    ))}
                  />
                </Form.Item>
                <Button onClick={handleUseCurrentLocation} variant="solid" color="primary" icon={<Icon width={20} icon={'duo-icons:location'} />} >
                  Gunakan Titik Saat Ini
                </Button>
              </Flex>
              <Card styles={{ body: { padding: 0 } }} >
                <MapComponent
                  position={position}
                  setPosition={setPosition}
                  reverseGeocodeMutation={reverseGeocodeMutation.mutate}
                />
              </Card>
            </RenderIf>
            <RenderIf when={stepPosition === 2} >
              <Row gutter={[20]} >
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="Regional"
                  // name={'pa_pc'}
                  >
                    <Input
                      value={data?.data.ab.REGIONAL}
                      readOnly
                      style={{ backgroundColor: pallete.grey[200] }}
                    />
                  </Form.Item>
                </Col>
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="AB"
                  >
                    <Input
                      value={data?.data.ab.NAMA_AB}
                      readOnly
                      style={{ backgroundColor: pallete.grey[200] }}
                    />
                  </Form.Item>
                </Col>
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="PA/PC"
                    name={'pa_pc'}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="BlOK/EZ"
                    name={'blok_ez'}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="NOVAK/BLOK"
                    name={'novak_blok'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="Nomen Terdekat"
                    name={'nomen_terdekat'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    label="CC"
                    name={'cc'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    label="Sumber air lain yang digunakan pelanggan"
                    name={'sumber_lain'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={sumberAir.map(e => ({ label: e, value: e }))}
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    label="Jaringan Pipa"
                    name={'jaringan_pipa'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 60 }} value={'Ada'} >Ada Jaringan</Radio>
                      <Radio value={'Tidak Ada'} >Tidak Ada Jaringan</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    label="Jarak bangunan dengan pipa existing PAM JAYA (m)"
                    name={'jarak_bangunan_dengan_pipa'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber suffix="m" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    label="Ukuran Pipa Input"
                    name={'ukuran_pipa_id'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={ukuranPipaMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    label="Diameter Pipa Dinas yang akan dipasang "
                    name={'diameter_pipa_id'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={diameterPipaMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                </Col>
                <Col span={24} >
                  <Form.Item
                    label="Jenis jalan/galian"
                    name={'jenis_jalan_id'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={jenisJalanMaster?.data?.items?.map(e => ({ label: e.name, value: e.id }))}
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Perlu crosing jalan"
                    name={'perlu_crossing_jalan'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Lebar Jalan"
                    name={'lebar_jalan'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber suffix="mm" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Perlu crosing saluran air"
                    name={'perlu_crossing_air'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Panjang casing pipa"
                    name={'panjang_casing_pipa'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber suffix="m" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Halaman"
                    name={'halaman'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="Sanitasi"
                    name={'sanitasi'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="Saluran Pembuangan"
                    name={'saluran_pembuangan'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={24} >
                  <Form.Item
                    label="Golongan Konsumen"
                    name={'golongan_konsumen_id'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={golonganKonsumenMaster?.data?.items?.map(e => ({ label: e.name, value: e.id }))}
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={12} >
                  <Form.Item
                    label="Nomen Lama"
                    name={'nomen_lama'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={12} >
                  <Form.Item
                    label="Tekanan Air"
                    name={'tekanan_air'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} suffix="m" />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={12} >
                  <Form.Item
                    label="Peruntukan Bangunan"
                    name={'peruntukan_bangunan'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'D'} >Domestic</Radio>
                      <Radio value={'Tidak'} >Non Domestic</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col sm={12} xs={12} >
                  <Form.Item
                    label="Perlu Bor Tembok"
                    name={'perlu_bor_tembok'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            </RenderIf>
            <RenderIf when={stepPosition == 3} >
              <Row gutter={[20]} >
                <Col span={12} >
                  <Form.Item
                    label="Kamar Tidur"
                    name={'kamar_tidur'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber min="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Kamar Mandi"
                    name={'kamar_mandi'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber min="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Ruang Tamu"
                    name={'ruang_tamu'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber min="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Ruang Makan"
                    name={'ruang_makan'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber min="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Ruang Keluarga"
                    name={'ruang_keluarga'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber min="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Dapur"
                    name={'dapur'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber min="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Teras"
                    name={'teras'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber min="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Garasi"
                    name={'garasi'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber min="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Gudang/Paviliun"
                    name={'gudang'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber min="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Jumlah Lantai"
                    name={'jumlah_lantai'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber min="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
              </Row>
            </RenderIf>
            <RenderIf when={stepPosition == 4} >
              <div style={{ marginBottom: 20 }} >
                <Upload
                  style={{ width: '100%', display: 'block' }}
                  rootClassName="survey-upload"
                  disabled={serviceLetter.length != 0}
                  beforeUpload={(file) => {
                    if (file.size > MAX_FILE_SIZE) {
                      message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
                      return Upload.LIST_IGNORE; // Mencegah upload
                    }
                    uploadServiceLetterMutation.mutateAsync({ serviceLetter: file })
                      .then(res => {
                        setServiceLetter([
                          {
                            ...res.data,
                            name: res?.data?.fileName,
                            size: res?.data?.fileSize,
                            preview: res?.data.filePath
                          }
                        ])
                        return false
                      })
                      .catch(err => console.log(err))
                  }}
                  fileList={serviceLetter}
                  onRemove={(file) => {
                    deleteFileMutation.mutateAsync(file.id)
                      .then(() => setServiceLetter([]))
                      .catch(err => console.log(err))
                  }}
                  itemRender={(_, file, filelist, action) => (
                    <UploadFileRenderer
                      file={file}
                      action={action}
                      deleteLoading={deleteFileMutation.isPending}
                      onPreview={() => setPrevieImage(file.preview)}
                    />
                  )}
                >
                  <Flex justify="space-between" >
                    <div style={{ flex: 1 }} >
                      <Typography.Text style={{ display: 'block' }} >
                        Surat Pelayanan Sementara
                      </Typography.Text>
                      <Typography.Text type="secondary" >
                        File jpeg, png, jpg, Max. file size: 2 MB
                      </Typography.Text>
                    </div>
                    <Button
                      icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                      disabled={serviceLetter.length != 0}
                    >
                      Upload
                    </Button>
                  </Flex>
                </Upload>
              </div>
              <div style={{ marginBottom: 20 }} >
                <Upload
                  style={{ width: '100%', display: 'block' }}
                  rootClassName="survey-upload"
                  disabled={additionalLetter.length == 5}
                  multiple
                  beforeUpload={(file) => {

                    if (file.size > MAX_FILE_SIZE) {
                      message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
                      return Upload.LIST_IGNORE;
                    }

                    uploadFileMutation.mutateAsync({ additionalLetter: file })
                      .then(res => {
                        const uploadedFiles = Array.isArray(res.data) ? res.data : [res.data];

                        const newFiles = uploadedFiles.map(e => ({
                          ...e,
                          name: e.fileName,
                          size: e.fileSize,
                          preview: `${API_BASE_URL}/files/${e.filePath}`
                        }));

                        setAdditionalLetter(prevAdditionalLetter => [
                          ...prevAdditionalLetter,
                          ...newFiles,
                        ]);
                      })
                      .catch(err => {
                        console.error("Error uploading file:", err);
                      });

                    return false;
                  }}
                  fileList={additionalLetter}
                  onRemove={(file) => {
                    deleteFileMutation.mutateAsync(file.id).then(() => {
                      const index = additionalLetter.indexOf(file);
                      const newFileList = additionalLetter.slice();
                      newFileList.splice(index, 1);
                      setAdditionalLetter(newFileList);
                    })
                  }}
                  itemRender={(_, file, filelist, action) => (
                    <UploadFileRenderer
                      file={file}
                      action={action}
                      deleteLoading={deleteFileMutation.isPending}
                      onPreview={() => setPrevieImage(file.preview)}
                    />
                  )}
                >
                  <Flex justify="space-between" >
                    <div style={{ flex: 1 }} >
                      <Typography.Text style={{ display: 'block' }} >
                        Dokumen Pendukung
                      </Typography.Text>
                      <Typography.Text type="secondary" >
                        File jpeg, png, jpg, Max. file size: 2 MB
                      </Typography.Text>
                    </div>
                    <Button
                      icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                      disabled={additionalLetter.length == 5}
                    >
                      Upload
                    </Button>
                  </Flex>
                </Upload>
              </div>
              <Form.Item
                label="Program Sambungan Baru"
                name={'program_sambungan_baru_id'}
                rules={[{ required: true }]}
              >
                <Select
                  options={programSambunganBaru?.data?.items?.map(e => ({ label: e.name, value: e.id }))}
                />
              </Form.Item>
              <Form.Item
                label="Skema Pembayaran"
                name={'skema_pembayaran'}
                rules={[{ required: true }]}
              >
                <Select
                  options={skemaPembayaran.map(e => ({ label: e, value: e }))}
                />
              </Form.Item>
              <Form.Item
                label="Program Kategori"
                name={'program_kategori'}
                rules={[{ required: true }]}
              >
                <Select
                  options={['Adhoc', 'Infill'].map(e => ({ label: e, value: e }))}
                />
              </Form.Item>
              <Form.Item
                label="Nama Program Kategori"
                name={'nama_program_kategori'}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Object ID BNBA"
                name={'object_id_bnba'}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Field Survey ID Field Maps BNBA"
                name={'field_survey_id_maps_bnba'}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Informasi Tambahan"
                name={'keterangan_lain'}
                rules={[{ required: true }]}
              >
                <Input.TextArea rows={5} />
              </Form.Item>
              <Descriptions
                column={1}
                layout={breakpoint.lg ? 'horizontal' : 'vertical'}
                bordered
                style={{ marginTop: 24 }}
                styles={{ label: { width: 110 }, content: { width: '100%' } }}
                size="small"
                items={[
                  {
                    label: 'KTP',
                    children: (
                      <Flex gap={8} align="center" >
                        <Typography.Text style={{ marginRight: 'auto' }}>{data?.data?.acceptance?.registration?.ktp}</Typography.Text>
                        <Flex gap={8} vertical={!breakpoint.lg} >
                          <Button
                            icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                            size="small"
                            variant="filled"
                            color="orange"
                            onClick={() => onChangeDocument('ktp')}
                          >
                            Ganti
                          </Button>
                          <Button
                            icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            disabled={!data?.data?.acceptance?.registration?.ktp}
                          >
                            <Link to={`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.ktp}?download=true`} >
                              Unduh
                            </Link>
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.ktp}`)}
                            disabled={!data?.data?.acceptance?.registration?.ktp}
                          >
                            Lihat
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => {
                              navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.ktp}`)
                              message.success('Link berhasil disalin')
                            }}
                          >
                            Salin Link
                          </Button>
                        </Flex>
                      </Flex>
                    )
                  },
                  {
                    label: 'KK',
                    children: (
                      <Flex gap={8} align="center" >
                        <Typography.Text style={{ marginRight: 'auto' }}>{data?.data?.acceptance?.registration?.kk}</Typography.Text>
                        <Flex gap={8} vertical={!breakpoint.lg} >
                          <Button
                            icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                            size="small"
                            variant="filled"
                            color="orange"
                            onClick={() => onChangeDocument('kk')}
                          >
                            Ganti
                          </Button>
                          <Button
                            icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            disabled={!data?.data?.acceptance?.registration?.kk}
                          >
                            <Link to={data?.data?.acceptance?.registration?.kk && `${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.kk}?download=true`} >
                              Unduh
                            </Link>
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.kk}`)}
                            disabled={!data?.data?.acceptance?.registration?.kk}
                          >
                            Lihat
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => {
                              navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.kk}`)
                              message.success('Link berhasil disalin')
                            }}
                          >
                            Salin Link
                          </Button>
                        </Flex>
                      </Flex>
                    )
                  },
                  {
                    label: 'PBB',
                    children: (
                      <Flex gap={8} align="center" >
                        <Typography.Text style={{ marginRight: 'auto' }}>{data?.data?.acceptance?.registration?.pbb ?? '-'}</Typography.Text>
                        <RenderIf when={data?.data?.acceptance?.registration?.pbb} >
                          <Flex gap={8} vertical={!breakpoint.lg} >
                            <Button
                              icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                              size="small"
                              variant="filled"
                              color="orange"
                              onClick={() => onChangeDocument('pbb')}
                            >
                              Ganti
                            </Button>
                            <Button
                              icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                              disabled={!data?.data?.acceptance?.registration?.pbb}
                            >
                              <Link to={data?.data?.acceptance?.registration?.pbb && `${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.pbb}?download=true`} >
                                Unduh
                              </Link>
                            </Button>
                            <Button
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                              icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.pbb}`)}
                              disabled={!data?.data?.acceptance?.registration?.pbb}
                            >
                              Lihat
                            </Button>
                            <Button
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                              icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              onClick={() => {
                                navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.pbb}`)
                                message.success('Link berhasil disalin')
                              }}
                            >
                              Salin Link
                            </Button>
                          </Flex>
                        </RenderIf>
                      </Flex>
                    )
                  },
                  {
                    label: 'Bangunan',
                    children: (
                      <Flex gap={8} align="center" >
                        <Typography.Text style={{ marginRight: 'auto' }}>{data?.data?.acceptance?.registration?.bangunan}</Typography.Text>
                        <Flex gap={8} vertical={!breakpoint.lg} >
                          <Button
                            icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                            size="small"
                            variant="filled"
                            color="orange"
                            onClick={() => onChangeDocument('bangunan')}
                          >
                            Ganti
                          </Button>
                          <Button
                            icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                          >
                            <Link to={`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.bangunan}?download=true`} >
                              Unduh
                            </Link>
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.bangunan}`)}
                          >
                            Lihat
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => {
                              navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.bangunan}`)
                              message.success('Link berhasil disalin')
                            }}
                          >
                            Salin Link
                          </Button>
                        </Flex>
                      </Flex>
                    )
                  },
                ]}
              />
            </RenderIf>
            <RenderIf when={stepPosition == 5} >
              <RenderIf when={tncAgree} >
                <Row gutter={[20, 20]} style={{ height: '100%' }} >
                  <Col xs={24} sm={12} style={{ display: 'flex', }} >
                    <RenderIf when={customerSignature.length > 0} >
                      <Flex align="center" gap={20} vertical style={{ margin: 'auto' }} >
                        <Card
                          cover={<img src={customerSignature} style={{ objectFit: 'cover' }} />}
                          style={{ height: 200 }}
                        />
                        <Flex vertical style={{ textAlign: 'center' }} >
                          <Typography>
                            {data?.data?.nama}
                          </Typography>
                          <Typography.Text style={{ color: pallete.primary.main }} >
                            Pelanggan
                          </Typography.Text>
                        </Flex>
                        <Button onClick={() => handleDeleteSignature('customer')} style={{ width: 'fit-content' }} variant="outlined" color="danger" >
                          Ulang
                        </Button>
                      </Flex>
                    </RenderIf>
                    <RenderIf when={customerSignature.length == 0} >
                      <Card style={{ width: breakpoint.xs ? '100%' : 'fit-content', margin: 'auto', }} >
                        <Space direction="vertical" align="center" size={'large'} style={{ width: breakpoint.xs ? '100%' : null }} >
                          <Icon
                            icon={'fluent:signature-20-regular'}
                            width={35}
                            height={35}
                          />
                          <Typography.Text type="secondary" >
                            Belum ada Tanda Tangan
                          </Typography.Text>
                          <Button onClick={() => handleSignature('customer')} variant="outlined" color="primary" >
                            Buat Customer
                          </Button>
                        </Space>
                      </Card>
                    </RenderIf>
                  </Col>
                  <Col xs={24} sm={12} style={{ display: 'flex' }} >
                    <RenderIf when={surveyorSignature.length > 0} >
                      <Flex align="center" gap={20} vertical style={{ margin: 'auto' }} >
                        <Card
                          cover={<img src={surveyorSignature} style={{ objectFit: 'cover' }} />}
                          style={{ height: 200 }}
                        />
                        <Flex vertical style={{ textAlign: 'center' }} >
                          <Typography>
                            {data?.data?.acceptance?.surveyor?.name}
                          </Typography>
                          <Typography.Text style={{ color: pallete.primary.main }} >
                            Surveyor
                          </Typography.Text>
                        </Flex>
                        <Button onClick={() => handleDeleteSignature('surveyor')} style={{ width: 'fit-content' }} variant="outlined" color="danger" >
                          Ulang
                        </Button>
                      </Flex>
                    </RenderIf>
                    <RenderIf when={surveyorSignature.length == '0'} >
                      <Card style={{ width: breakpoint.xs ? '100%' : 'fit-content', margin: 'auto', }} >
                        <Space direction="vertical" align="center" size={'large'} style={{ width: breakpoint.xs ? '100%' : null }} >
                          <Icon
                            icon={'fluent:signature-20-regular'}
                            width={35}
                            height={35}
                          />
                          <Typography.Text type="secondary" >
                            Belum ada Tanda Tangan
                          </Typography.Text>
                          <Button onClick={() => handleSignature('surveyor')} variant="outlined" color="primary" >
                            Buat Surveyor
                          </Button>
                        </Space>
                      </Card>
                    </RenderIf>
                  </Col>
                </Row>
              </RenderIf>
              <RenderIf when={!tncAgree} >
                <div style={{ overflowY: 'auto' }} >
                  <TnC />
                  <Divider />
                  <Button onClick={() => setTnCAgree(true)} block variant="solid" color="primary"  >
                    Saya Menyetujui Syarat dan Ketentuan
                  </Button>
                </div>
              </RenderIf>
            </RenderIf>
            <RenderIf when={stepPosition == 6} >
              <div style={{ marginBottom: 20 }} >
                <Upload
                  style={{ width: '100%', display: 'block' }}
                  rootClassName="survey-upload"
                  disabled={customerImage.length != 0}
                  beforeUpload={(file) => {
                    if (file.size > MAX_FILE_SIZE) {
                      message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
                      return Upload.LIST_IGNORE; // Mencegah upload
                    }
                    uploadCustomerImageMutation.mutateAsync({ image: file })
                      .then(res => {
                        setCustomerImage([
                          {
                            ...res.data,
                            name: res?.data?.fileName,
                            size: res?.data?.fileSize,
                            preview: `${API_BASE_URL}/files/` + res?.data.filePath
                          }
                        ])
                        return false
                      })
                      .catch(err => console.log(err))
                  }}
                  fileList={customerImage}
                  onRemove={(file) => {
                    deleteFileMutation.mutateAsync(file.id)
                      .then(() => setCustomerImage([]))
                      .catch(err => console.log(err))
                  }}
                  itemRender={(_, file, filelist, action) => (
                    <UploadFileRenderer
                      file={file}
                      action={action}
                      deleteLoading={deleteFileMutation.isPending}
                      onPreview={() => setPrevieImage(file.preview)}
                    />
                  )}
                >
                  <Flex justify="space-between" >
                    <div style={{ flex: 1 }} >
                      <Typography.Text style={{ display: 'block' }} >
                        Foto Pelanggan
                      </Typography.Text>
                      <Typography.Text type="secondary" >
                        File jpeg, png, jpg, Max. file size: 2 MB
                      </Typography.Text>
                    </div>
                    <Button
                      icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                      disabled={serviceLetter.length != 0}
                    >
                      Upload
                    </Button>
                  </Flex>
                </Upload>
              </div>
            </RenderIf>
          </Form>
          <RenderIf when={!breakpoint.xs} >
            <div style={{ width: 200, borderLeft: '.5px solid ' + pallete.grey[400], paddingLeft: 20 }} >
              <Steps
                current={stepPosition}
                onChange={(val) => {
                  if (val > stepPosition) handleNext()
                }}
                items={[
                  {
                    title: <Typography.Text>Pelanggan</Typography.Text>,
                  },
                  {
                    title: <Typography.Text>Titik Koordinat</Typography.Text>,
                  },
                  {
                    title: <Typography.Text>Lokasi</Typography.Text>,
                  },
                  {
                    title: <Typography.Text>Bangunan</Typography.Text>,
                  },
                  {
                    title: <Typography.Text >Dokumen & Informasi Tambahan</Typography.Text>,
                  },
                  {
                    title: <Typography.Text>Persetujuan</Typography.Text>,
                  },
                  {
                    title: <Typography.Text>Foto Pelanggan</Typography.Text>,
                  }
                ]}
                direction="vertical"
                style={{ height: 450 }}
              />
            </div>
          </RenderIf>
        </Flex>
      </Card>
      <Modal
        open={previewImage.length > 0}
        centered
        title="Gambar"
        onCancel={() => setPrevieImage('')}
        footer={[
          <Button variant="outlined" color="primary" key="cancel" onClick={() => setPrevieImage('')}>
            Cancel
          </Button>
        ]}
      >
        <embed style={{ width: '100%', height: getFileExtension(previewImage) == 'pdf' && '500px' }} src={previewImage} />
      </Modal>
      <Modal
        open={openChangeModal}
        onCancel={handleCloseChangedDocumentModal}
        title="Ganti Berkas"
        centered
        okText="Submit"
        okButtonProps={{
          disabled: !changedDocument.length,
          onClick: handleChangeDocument
        }}
        styles={{
          body: {
            paddingTop: 20,
            paddingBottom: 20,
          }
        }}
      >
        <Upload
          style={{ width: '100%', display: 'block' }}
          rootClassName="survey-upload"
          beforeUpload={async (file) => {
            await preprocessUpload(file)
            setChangedDocument([file])
            return false
          }}
          fileList={changedDocument}
          onRemove={() => {
            setChangedDocument([])
          }}
          itemRender={(_, file, filelist, action) => (
            <UploadFileRenderer
              file={file}
              action={action}
              onPreview={() => setPrevieImage(file.preview)}
            />
          )}
        >
          <Flex justify="space-between" >
            <div style={{ flex: 1 }} >
              <Typography.Text style={{ display: 'block' }} >
                <Typography.Text style={{ color: 'red', marginRight: 6 }} >
                  *
                </Typography.Text>
                Upload Dokumen Pengganti
              </Typography.Text>
              <Typography.Text type="secondary" style={{ paddingLeft: 11 }} >
                File jpeg, png, jpg, Max. file size: 2 MB
              </Typography.Text>
            </div>
            <Button
              icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
            >
              Upload
            </Button>
          </Flex>
        </Upload>
      </Modal>
    </>
  )
}